export const POPUP_TYPE = {
  play: 1,
  buy: 2
}
